export default "__VITE_ASSET__b5bc58ad__"